import { render, staticRenderFns } from "./DojoSettingsModal.vue?vue&type=template&id=3bb0ab50&"
import script from "./DojoSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./DojoSettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./DojoSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports